import React, { useState } from 'react';
import {
  Button,
  TableCell,
  TableRow,
  Chip,
  Avatar,
  Box,
  Tooltip,
} from '@material-ui/core';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import { map } from 'lodash';

const StoreTableRow = (props) => {
  const { store, toEditStore } = props;
  const [showAllBenefits, setShowAllBenefits] = useState(false);

  const MAX_DISPLAY_BENEFITS = 2;
  const MAX_BENEFIT_TEXT_LENGTH = 20;

  const handleEdit = () => {
    toEditStore(store.id);
  };

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const renderBenefits = () => {
    if (
      !store.payingMemberBenefits ||
      store.payingMemberBenefits.length === 0
    ) {
      return <span style={{ color: '#999' }}>無福利項目</span>;
    }

    const benefits = store.payingMemberBenefits;
    const displayBenefits = showAllBenefits
      ? benefits
      : benefits.slice(0, MAX_DISPLAY_BENEFITS);
    const remainingCount = benefits.length - MAX_DISPLAY_BENEFITS;

    return (
      <Box display="flex" flexWrap="wrap" gap={0.5} alignItems="center">
        {map(displayBenefits, (benefit, index) => (
          <Tooltip key={index} title={benefit} arrow placement="top">
            <Chip
              size="small"
              label={truncateText(benefit, MAX_BENEFIT_TEXT_LENGTH)}
              color="primary"
              variant="outlined"
              style={{ margin: '2px', maxWidth: '200px' }}
            />
          </Tooltip>
        ))}
        {!showAllBenefits && remainingCount > 0 && (
          <Tooltip
            title={
              <Box>
                {benefits.slice(MAX_DISPLAY_BENEFITS).map((benefit, index) => (
                  <div key={index} style={{ marginBottom: '4px' }}>
                    • {benefit}
                  </div>
                ))}
              </Box>
            }
            arrow
            placement="top">
            <Chip
              size="small"
              label={`+${remainingCount} 項`}
              color="default"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                setShowAllBenefits(true);
              }}
              style={{
                margin: '2px',
                cursor: 'pointer',
                backgroundColor: '#f5f5f5',
              }}
            />
          </Tooltip>
        )}
        {showAllBenefits && benefits.length > MAX_DISPLAY_BENEFITS && (
          <Chip
            size="small"
            label="收起"
            color="default"
            variant="outlined"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllBenefits(false);
            }}
            style={{ margin: '2px', cursor: 'pointer' }}
          />
        )}
      </Box>
    );
  };

  return (
    <TableRow>
      <TableCell component="th">
        {store.imgSrc && (
          <Avatar
            alt={store.name}
            src={store.imgSrc}
            variant="rounded"
            style={{ width: 60, height: 60 }}
          />
        )}
      </TableCell>
      <TableCell component="th">{store.id}</TableCell>
      <TableCell>{store.name}</TableCell>
      <TableCell>
        {store.staffUserInfo ? (
          <Chip
            size="small"
            label={store.staffUserInfo.email || store.staffUserInfo.cellPhone}
          />
        ) : (
          <span style={{ color: '#999' }}>未設定</span>
        )}
      </TableCell>
      <TableCell>{renderBenefits()}</TableCell>
      <TableCell align="right">
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<EditRoundedIcon />}
          onClick={handleEdit}>
          編輯
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default StoreTableRow;
